import { DEFAULT_LOCALE_COOKIE_NAME } from '@/constants';
import { createSlice } from '@reduxjs/toolkit';
import { getCookie } from 'cookies-next';
import { statusTypes } from '@/constants/types';
import fetchGlobalSettings from '../thunk/global-setting-thunk';

const initialLang = getCookie(DEFAULT_LOCALE_COOKIE_NAME) || 'en';

const initialState = {
  lang: initialLang,
  fetchStatus: statusTypes.idle,
  error: null,
  colorSchema: 'light',
  minEMIPrice: 0,
  homePagePromotionalText: {
    en: '',
    bn: '',
  },
  installationFeeHelpText: null,
  isVisiblePromotionOffer: true,
  data: null,
  showSpinTheWheelPopup: false,
};

const globalSettingsSlice = createSlice({
  name: 'globalSettings',
  initialState,
  reducers: {
    setLang: (state, action) => {
      state.lang = action.payload;
    },
    setIsVisiblePromotionOffer: (state, action) => {
      state.isVisiblePromotionOffer = action.payload;
    },
    restGlobalSettingForCache: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGlobalSettings.pending, (state) => {
        state.fetchStatus = statusTypes.loading;
        state.error = null;
      })
      .addCase(fetchGlobalSettings.fulfilled, (state, action) => {
        state.homePagePromotionalText =
          action.payload?.home_page_promotional_text ?? null;
        state.minEMIPrice = action?.payload?.min_emi_amount ?? 0;
        state.installationFeeHelpText =
          action?.payload?.installation_fee_help_text ?? null;
        state.data = action?.payload;
        state.showSpinTheWheelPopup =
          action?.payload?.spin_the_wheel_popup ?? false;
        state.fetchStatus = statusTypes.succeeded;
      })
      .addCase(fetchGlobalSettings.rejected, (state, action) => {
        state.fetchStatus = statusTypes.idle;
        state.error = action.payload;
      });
  },
});

export const {
  setLang,
  restGlobalSettingForCache,
  setIsVisiblePromotionOffer,
} = globalSettingsSlice.actions;

export default globalSettingsSlice.reducer;
